import { useMutation } from '@tanstack/react-query';

import { FlightEventClient, FlightEventFlightDetailsLookup } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);

function useCreateNewFlightEvent() {
  return useMutation({
    mutationKey: [queryKeys.FlightEvent.CreateNew],
    mutationFn: (lookup: FlightEventFlightDetailsLookup) => flightEventClient.createNew(lookup),
  });
}

export default useCreateNewFlightEvent;
